import { css } from '@emotion/react';
import { DesignToken, RadiusToken, SpacingToken } from '@livechat/design-system-react-components';
import { MEDIA_MAX_SM, MEDIA_MIN_SM } from '_assets/css/breakpoints';

export const container = css`
  display: flex;
  flex-direction: column;
  margin-top: var(${SpacingToken.Spacing7});
  padding: 0 var(${SpacingToken.Spacing5});
  gap: var(${SpacingToken.Spacing7});

  ${MEDIA_MIN_SM} {
    margin-top: 90px;
  }
`;

export const heading = css`
  display: flex;
  flex-direction: column;
  gap: var(${SpacingToken.Spacing2});
`;

export const subHeading = css`
  color: var(${DesignToken.ContentBasicSecondary});
  font-weight: 600;
`;

export const formField = css`
  width: 100%;
`;

export const passwordField = css`
  width: 100%;
  margin-bottom: var(${SpacingToken.Spacing3});
`;

export const signUpWrapper = css`
  width: 100%;
  max-width: 360px;
  margin: 0 auto;
`;

export const formWrapper = css`
  margin-bottom: var(${SpacingToken.Spacing10});
`;

export const phoneInput = css`
  width: 100%;

  .iti {
    display: flex;
    align-items: center;
    height: 44px;

    --iti-path-flags-1x: url('${import.meta.env.VITE_CDN_TEXT_PATH}organization/phone/flags.webp');
    --iti-path-flags-2x: url('${import.meta.env
      .VITE_CDN_TEXT_PATH}organization/phone/flags@2x.webp');
  }

  .iti__selected-country-primary {
    padding-left: 14px;
    padding-right: 8px;
  }

  .iti__tel-input,
  .iti__tel-input__error {
    padding-left: 60px !important;
    outline: none;
    height: 44px;
    width: -webkit-fill-available;
    width: -moz-available;
    font-size: 14px;
    color: var(${DesignToken.ContentBasicPrimary});
    border-style: solid;
    border-width: 1px;
    border-radius: var(${RadiusToken.Radius3});
  }

  .iti__tel-input {
    border-color: var(${DesignToken.BorderBasicPrimary});

    &:hover {
      border-color: var(${DesignToken.BorderBasicHover});
    }

    &:active,
    &:focus {
      border-color: var(${DesignToken.ActionPrimaryDefault});
    }
  }

  .iti__tel-input__error {
    border-color: var(${DesignToken.BorderBasicNegative});
  }

  .iti__search-input {
    height: 40px;
    outline: none;
    font-size: 14px;
    color: var(${DesignToken.ContentBasicPrimary});
    border-radius: var(${RadiusToken.Radius3});
  }

  .iti__dropdown-content {
    border-radius: var(${RadiusToken.Radius3});
  }

  .iti__country {
    height: 40px;
    font-size: 14px;
  }

  .iti__country-name {
    color: var(${DesignToken.ContentBasicPrimary});
  }

  .iti__dial-code {
    color: var(${DesignToken.ContentBasicDisabled});
  }

  .iti__selected-dial-code {
    font-size: 14px;
    color: var(${DesignToken.ContentBasicPrimary});

    ${MEDIA_MAX_SM} {
      font-size: 16px !important;
    }
  }
`;

export const signUpButton = css`
  width: 100%;
`;

export const signupLegalInfo = css`
  margin-top: var(${SpacingToken.Spacing4});
`;
